<template>
  <div id="detailsLeft">
    <div class="detailsLeft">
      <p @click="getTo()" class="titlefont aqt_lang_mn">
        {{ $t("m.home") | U2M }}
      </p>
      <p
        v-if="title_left"
        @click="$router.go(-1)"
        class="p2 titlefont aqt_lang_mn"
      >
        {{ title_left | U2M }}
      </p>
      <p :class="title_left ? 'p3' : 'p4'" class="titlefont aqt_lang_mn">
        {{ $t("m.details") | U2M }}
      </p>
      <p></p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title_left: "",
    };
  },
  methods: {
    getTo() {
      this.$router.push({
        path: "/aqt",
        query: {
          lib_type: sessionStorage.getItem("gcm"),
        },
      });
    },
  },
  created() {
    let that = this;
    if (that.$route.query.title_left) {
      let str = JSON.parse(that.$crypto.get(that.$route.query.title_left));
      that.title_left = str.substring(1, str.length - 1);
    }
  },
};
</script>

<style lang="less" scoped>
#detailsLeft {
  width: 68px;
  height: 100%;
  display: flex;
  justify-content: center;
  .detailsLeft {
    width: 46px;
    height: 100%;
    background: #ffffff;
    p {
      width: 100%;
      padding: 20px 0;
      font-size: 20px;
      color: #14216c;
      text-align: center;
      line-height: 1px;
    }
    p:nth-child(1) {
      background: #f2f9fa;
      min-height: 140px;
      line-height: 46px !important;
      cursor: pointer;
    }
    .p2 {
      background: #cee0ff;
      min-height: 150px;
      border-top: 23px solid #f2f9fa;
      border-left: 23px solid transparent;
      border-right: 23px solid transparent;
      cursor: pointer;
    }
    .p3 {
      background: #b9d3ff;
      min-height: 170px;
      border-top: 23px solid #cee0ff;
      border-left: 23px solid transparent;
      border-right: 23px solid transparent;
    }
    .p4 {
      background: #b9d3ff;
      min-height: 170px;
      border-top: 23px solid #f2f9fa;
      border-left: 23px solid transparent;
      border-right: 23px solid transparent;
    }
    p:last-child {
      min-height: 170px;
      border-top: 23px solid #b9d3ff;
      border-left: 23px solid transparent;
      border-right: 23px solid transparent;
    }
  }
}
</style>
